import TextImageBlock from "../text-image-block/TextImageBlock";

export default function Context(){
    return(
        <TextImageBlock 
            id='context'
            title='Context' 
            text="This extraordinary product is evolving within the framework of 
            the final project of the LECI course at the Universidade de Aveiro. 
            It stands as a testament to the academic excellence and forward-thinking 
            approach of our students. Guided by experts, this project seamlessly 
            merges technology with the knowledge cultivated in the academic 
            environment. Immerse yourself in the harmonious blend of education and innovation 
            by joining us on this transformative journey."
            img='../static-images/school.png'
            imgClass='image-context'
        />
    );
}